module.exports = __webpack_public_path__ + "img/7.6fc559f1.png";